export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL21lZGlhL3doYXRzYXBwLjVmMzJhNjgxLnBuZyI7"